import { useState, useEffect } from "react";
import { Icon, Link, IconButton, Box } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { ArrowUpIcon } from "@chakra-ui/icons";
import { FaWhatsapp } from "react-icons/fa";

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  6.25% { transform: rotate(45deg); }
  12.50% { transform: rotate(-90deg); }
  18.75% { transform: rotate(45deg); }
  25%,100% { transform: rotate(0deg); } /* Rotates back */
  
  /* Delay effect: No movement for 6 seconds */
  /* 100%, 200% { transform: rotate(0deg); }  */
`;

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <Link
        href="https://wa.me/919256491206"
        target="_blank"
        rel="noopener"
        aria-label="Chat with Qualiteeth Dental Care on WhatsApp"
      >
        <Box
          position="fixed"
          bottom={{
            base: isVisible ? "160px" : "80px",
            md: isVisible ? "80px" : "20px",
          }}
          right={{ base: "16px", md: "20px" }}
          zIndex="1000"
          bg="#28211d"
          color="#F5C7A9"
          _hover={{ color: "#c49d84" }}
          size="lg"
          borderRadius="full"
          boxShadow="md"
          display="flex"
          alignItems="center"
          justifyContent="center"
          boxSize={12} // Outer box remains large
          css={{
            animation: `${rotate} 6s ease-in-out infinite`, // 1s rotation + 6s delay
          }}
        >
          <Icon as={FaWhatsapp} w={7} h={7} />
        </Box>
      </Link>
      {isVisible && (
        <IconButton
          aria-label="Scroll to top"
          icon={<ArrowUpIcon boxSize={6} />}
          onClick={scrollToTop}
          position="fixed"
          bottom={{ base: "100px", md: "20px" }}
          right={{ base: "16px", md: "20px" }}
          zIndex="1000"
          bg="#28211d"
          color="#F5C7A9"
          _hover={{ color: "#c49d84" }}
          size="lg"
          isRound={true} // Makes it circular
          boxShadow="md"
        />
      )}
    </>
  );
};

export default ScrollToTop;
